import { SortType } from '@/models/SortType';
import { TableHeader } from '@/models/TableHeader';
import { ReglementDTO } from '@/models/ReglementDTO';

export interface ReglementFournisseurState {
    reglements: ReglementDTO[];

    filtreOperateur?: string;
    filtreMontant?: number;
    filtreSociete?: string;
    filtreDateDebut?: string;
    filtreDateFin?: string;

    isLoading: boolean;
    isXlsLoading: boolean;

    sort?: {
        sortData: string;
        sortStatus: SortType;
    };
    tableHeader: TableHeader[];
    page: number;
    numberOfPage: number;
    scroll: number;
    count: number;
}

export const initialState: ReglementFournisseurState = {
    reglements: [],

    isLoading: false,
    isXlsLoading: false,

    tableHeader: [
        {
            label: 'reglements.fournisseur.table.date',
            sortData: 'date_reglement',
            sortStatus: SortType.NONE,
            width: '34%',
        },
        {
            label: 'reglements.fournisseur.table.numero',
            sortData: 'numero_reglement',
            sortStatus: SortType.NONE,
            width: '33%',
        },
        {
            label: 'reglements.fournisseur.table.montant',
            sortData: 'montant_ttc',
            sortStatus: SortType.NONE,
            width: '33%',
        },
    ],
    page: 0,
    numberOfPage: 0,
    scroll: 0,
    count: 0,
};

export const state: ReglementFournisseurState = {
    ...initialState
};
